module.exports = __webpack_public_path__ + "img/Shop2ufoot.176dc4fb.png";